// @flow

import Vue from 'vue'
import VueI18n from 'vue-i18n'

import { defaultLocale, messages } from '../locales'

Vue.use(VueI18n)

// $FlowFixMe
export const i18n = new VueI18n({
  locale: defaultLocale,
  fallbackLocale: defaultLocale,
  messages
})
